import { useState } from 'react'
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom'

import { Button, Container, ContentBox, Link, Row, Stack, Text, Typography } from '../components'
import { LoginForm } from '../components/login/login-form'
import { useBrandingContext } from '../context'
import { DeleteAccountModal } from '../components/delete-account-modal'

export function Login({ confirmAccountLogin = false, charityUser = false, afterLogin: afterLoginProp }) {
  const navigate = useNavigate()
  const location = useLocation()
  const branding = useBrandingContext()
  const { afterLogin: afterLoginState, prefillEmail } = location.state ?? {}
  const afterLogin = afterLoginProp ?? afterLoginState
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const onCompleted = () => {
    let destination = charityUser ? '/charities/confirm' : '/'

    if (afterLogin) {
      destination = afterLogin.includes('/funds') ? '/' : afterLogin
    }

    console.log(`navigating to ${destination}`)
    console.log(charityUser)
    navigate(destination)
  }

  const handleDeleteClick = (e) => {
    e.preventDefault()
    setShowDeleteModal(true)
  }

  return (
    <>
      <Container maxWidth="sm">
        <Stack spacing={4}>
          {confirmAccountLogin ? (
            <>
              <Text.H1>{charityUser ? 'My Charity Account' : 'My Giving Fund'}</Text.H1>
              <Text.H5 component="h1" align="left" data-testid="welcomeTitle">
                To Confirm Account, Please Log In
              </Text.H5>
            </>
          ) : (
            <Text.H5 component="h1" align="center" data-testid="welcomeTitle">
              {branding?.getLabelValue('LoginTitle')}
            </Text.H5>
          )}

          <ContentBox border>
            <LoginForm {...{ prefillEmail, onCompleted }} />
          </ContentBox>

          {!confirmAccountLogin && (
            <Row alignSelf="flex-end" justifyContent="flex-end" alignItems="center" spacing={4} px={4}>
              <Typography variant="body2" data-testid="notHaveAccountText">
                Don&rsquo;t have an account with us yet?
              </Typography>
              <Button
                component={RouterLink}
                to="/sign-up"
                state={{ afterLogin }}
                size="large"
                color="info"
                data-testid="signUpButton"
              >
                Sign Up
              </Button>
            </Row>
          )}
          <Row alignSelf="flex-end" justifyContent="flex-end" alignItems="center" spacing={4} pr={9}>
            <Text.Body variant="body2" data-testid="haveAccountText">
              Click{' '}
              <button
                type="button"
                onClick={handleDeleteClick}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'inherit',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  padding: 0,
                  font: 'inherit',
                }}
              >
                here
              </button>{' '}
              {`to delete your ${branding?.platformName || 'GiveWise'} Giving Fund`}
            </Text.Body>
          </Row>
        </Stack>
      </Container>

      <DeleteAccountModal open={showDeleteModal} onClose={() => setShowDeleteModal(false)} />
    </>
  )
}
